<template>
  <div class="home">
    <br>
    <div>
    <h1 class="white">godService.nu</h1>
    <h1 class="white">Vi skaber en grønnere hverdag</h1>
  </div>
  </div>
</template>

<script>
// @ is an alias to /src


export default {
  name: 'HomeView',
  components: {
    
  }
}
</script>

<style scoped>

.home {
  background: url('@/assets/Windmill.gif');
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: calc(100vh - 110px);
  background-position-y: 0px

}
</style>